module.exports = __webpack_public_path__ + "static/media/fastighetsagarna-sverigekarta.5464eee9.svg";